import { motion } from "framer-motion";
import paganiRollers from "@/assets/pagani-huayra-rollers.jpg";

const Craftsmanship = () => {
  return (
    <section className="py-24 bg-secondary/30">
      <div className="container">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Image */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="relative overflow-hidden rounded-lg"
          >
            <img
              src={paganiRollers}
              alt="Pagani Huayra serviced by Hyper Haus"
              loading="lazy"
              width={612}
              height={1087}
              className="w-full h-full object-cover aspect-[4/5] lg:aspect-[3/4]"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-background/60 to-transparent" />
          </motion.div>

          {/* Content */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, delay: 0.2 }}
          >
            <p className="text-primary text-sm uppercase tracking-[0.3em] mb-4">
              Our Promise
            </p>
            <h2 className="section-heading mb-6">
              HyperCar Craftsmanship for All
            </h2>
            <div className="space-y-5 text-muted-foreground">
              <p className="text-lg leading-relaxed">
                Every vehicle that rolls into Hyper Haus receives the same meticulous process and
                obsessive attention to detail that we give to a $5&nbsp;million hypercar — because
                your car deserves nothing less.
              </p>
              <p className="leading-relaxed">
                Our team has hands-on experience with some of the rarest and most demanding machines
                ever built: <span className="text-foreground font-medium">Paganis, Koenigseggs, Bugattis, McLarens,
                Aston Martins, vintage Ferraris,
                classic Lamborghinis, and air-cooled Porsches.</span> These cars taught us that there
                is no room for shortcuts — and we carry that standard into every single job.
              </p>
              <p className="leading-relaxed">
                Whether you drive a daily sedan or a million-dollar collectible, you'll get the same
                world-class preparation, premium materials, and white-glove service. We don't
                overcharge, and we never cut corners. Every vehicle deserves hypercar-level care,
                and every owner deserves to feel welcome the moment they walk through our doors.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Craftsmanship;
